module.exports = __webpack_public_path__ + "static/media/cz.153e33f0.svg";